import React, {FC, ReactNode} from 'react';
import {Row, Col} from 'antd';
import {AuctionType} from '@joyrideautos/ui-models/src/types/auction/Auction';

interface AuctionsGridProps {
    auctions: AuctionType[];
    render: (item: AuctionType) => ReactNode;
}

export const AuctionsGrid: FC<AuctionsGridProps> = ({auctions, render}) => {
    return (
        <Row className="section-card-item">
            {auctions.map((auction) => {
                return (
                    <Col xs={24} sm={12} md={8} lg={6} xl={6} key={auction.auctionId}>
                        {render(auction)}
                    </Col>
                );
            })}
        </Row>
    );
};
